import { useCallback } from "react";

const useUpdateUrlParam = (paramKey) => {
    return useCallback((value) => {
        if (!paramKey) {
            return;
        }

        const url = new URL(window.location.href);

        if (value === undefined || value === null || value === "") {
            url.searchParams.delete(paramKey);
        } else {
            url.searchParams.set(paramKey, value);
        }

        window.history.replaceState({}, "", url.toString());
    }, [paramKey]);
};

export default useUpdateUrlParam;
